<template>
  <!-- <page-frame> -->
  <page-frame headStyle="height:2.12rem;" bodyStyle="top:2.12rem;">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_productlist_fanhui") }}</span>
      <span>{{ $t("system.ResetPassword") }}{{ Step }}/{{ TotalStep }}</span>
    </header-bar>

    <div class="Reset-info">
      <div class="Rest-wrapper" v-if="Step == 1">
        <br />
        <br />
        <van-field label="用户名" v-model="model.UserAct" :placeholder="$t('placeholders.Account')" :rules="[{ required: true, message: ' ' }]" clearable />
        <br />
        <van-field label="验证码" class="smsVerification" v-model="model.Code" center clearable :placeholder="$t('placeholders.VerificationCode')">
          <template #button>
            <img :src="ValidImg" style="height:0.:98rem;vertical-align: middle;" @click="changImg" />
          </template>
        </van-field>
        <br />
        <br />

        <div class="wrapShim">
          <van-button round block type="info" @click="CheckAccount">{{ $t("share.SubmitBtn") }}</van-button>
        </div>
      </div>
      <div class="Rest-wrapper" style="padding-top:0.532rem;" v-if="Step == 2">
        <div v-for="ResetWay in ResetWays" :key="ResetWay">
          <br />
          <div class="Reset-resetWays wrapShim">
            <span v-if="ResetWay.value == 'phone'">{{ $t("system.PhoneHint") }}</span>
            <span v-if="ResetWay.value == 'email'">{{ $t("system.EmailHint") }}</span>

            <!-- {{ $t("ResetWay.label") }} -->
            <van-button type="info" size="small" @click="ChangeWays(ResetWay)">{{ $t(textCode) }} </van-button>
          </div>
          <!-- <div v-if="model.ValidType == ResetWay.value"> -->

          <van-field label="验证码" class="smsVerification" v-model="model.ValidCode" center clearable :placeholder="$t('placeholders.VerificationCode')">
            <template #button>
              <van-button size="small" type="primary" @click="CheckValidCode">{{ $t("share.confirmTxt") }}</van-button>
            </template>
          </van-field>
          <br />
        </div>
      </div>
      <div class="Rest-wrapper" style="padding-top:0.532rem;" v-if="Step == 3">
        <van-field :label="$t('system.LoginPassword')" v-model="model.UserPwd" type="password" :placeholder="$t('placeholders.Password')" clearable> </van-field>
        <br />
        <van-field :label="$t('system.AffirmNewPassword')" v-model="model.ConfirmPwd" type="password" :placeholder="$t('placeholders.AffirmNewPassword')" clearable> </van-field>
        <br />
        <br />
        <div class="wrapShim">
          <van-button round block type="info" size="normal" @click="ResetPwd">{{ $t("share.AmendBtn") }}</van-button>
        </div>
      </div>
    </div>
  </page-frame>
</template>
<style scoped>
  .wrapShim {
    padding: 0.5rem;
  }

  .Reset-info {
    background-color: #f7f8fa;
    height: 100%;
  }
  .Reset-resetWays {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .Reset-resetWays > span:first-child {
    font-size: 0.372rem;
  }
</style>

<script>
  import sideService from "@/service/sideService";
  import UserService from "@/service/UserService";
  import navBar from "../modules/navBar.vue";
  import { Form, Field, Toast } from "vant";
  export default {
    data() {
      return {
        objSave: {
          centerTitle: "system.ForgetPassword",
        },
        Step: 1,
        TotalStep: 3,
        ValidImg: "",
        model: {
          UserAct: "",
          Code: "",
          ValidType: "",
          ValidCode: "",
          ConfirmPwd: "",
          UserPwd: "",
        },

        textCode: "login_fasongyanzhengma",
        judgeCode: true,
        setInterval: 0,
        ResetWays: [
          {
            label: "system.PhoneVerification",
            value: "phone",
          },
          {
            label: "system.EmailVerification",
            value: "email",
          },
        ],
      };
    },
    mounted() {
      let __self = this;
      __self.ValidImg = sideService.getValidImageUrl();
      $(window).bind("popstate", e => {
        if (__self.Step > 1) {
          __self.Step--;
        }
      });
    },
    methods: {
      ChangeWays(ResetWay) {
        let __self = this;
        let data = {
          UserAct: __self.model.UserAct,
          ValidType: ResetWay.value,
        };

        if (!__self.judgeCode) {
          return;
        }
        __self.judgeCode = false;
        let $time = 60;

        function run() {
          __self.textCode = __self.$t("system.Sent") + "(" + --$time + ")";
          if ($time <= 0) {
            clearInterval(__self.setInterval);
            __self.textCode = "login_fasongyanzhengma";
            __self.judgeCode = true;
          } else {
            __self.judgeCode = false;
          }
        }

        UserService.sendCode(data).then(json => {
          if (!json.isSucc) {
            return this.$root.$toast(json.message);
          }
          __self.setInterval = setInterval(run, 1000);
          __self.model.ValidType = ResetWay.value;
          __self.judgeCode = true;
        });
      },
      changImg() {
        this.ValidImg = sideService.getValidImageUrl();
      },
      CheckAccount() {
        let __self = this;
        if (__self.model.Code == "") {
          return this.$root.$toast(__self.$t("RegExp.VerificationCodeReg.isEmpty"));
        }
        let data = {
          UserAct: __self.model.UserAct,
          Code: __self.model.Code,
        };
        UserService.checkAccount(data).then(json => {
          if (!json.isSucc) {
            return this.$root.$toast(json.message);
          }
          let results = json.result;
          _.remove(__self.ResetWays, function(o) {
            for (let i = 0; i < results.length; i++) {
              return o.value != results[i];
            }
          });
          __self.Step++;
          history.pushState({}, __self.Step, location.href);
        });
      },
      CheckValidCode() {
        let __self = this;
        if (__self.model.ValidCode == "") {
          return this.$root.$toast(__self.$t("RegExp.VerificationCodeReg.isEmpty"));
        }
        let data = {
          UserAct: __self.model.UserAct,
          Code: __self.model.ValidCode,
        };
        UserService.checkCode(data).then(json => {
          if (!json.isSucc) {
            return this.$root.$toast(json.message);
          }
          __self.Step++;
          history.pushState({}, __self.Step, location.href);
        });
      },
      back() {
        let __self = this;
        history.back();
      },
      ResetPwd() {
        let __self = this;
        let data = {
          UserAct: __self.model.UserAct,
          UserPwd: __self.model.UserPwd,
          Code: __self.model.ValidCode,
          ConfirmPwd: __self.model.ConfirmPwd,
        };
        UserService.resetPwd(data).then(json => {
          if (!json.isSucc) {
            this.$root.$toast.fail(json.message);
            return;
          }
          this.$root.$toast.success(__self.$t("share.succ.ChangePasswordSucc"));
          setTimeout(function() {
            __self.$router.push({
              path: "/login",
            });
          }, 1000);
        });
      },
    },
    components: {
      navBar,
      [Form.name]: Form,
      [Field.name]: Field,
    },
  };
</script>
